<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import AppLayout from '@/layouts/AppLayout.vue'
import AuthLayout from '@/layouts/AuthLayout.vue'
import ConfirmDialog from '@/components/ui/ConfirmDialog.vue'
import { useTheme } from '@/composables/useTheme'

const route = useRoute()
const layout = computed(() => {
  if (route.meta.layout === 'auth') return AuthLayout
  if (route.meta.layout === 'none') return null
  return AppLayout
})

// Init theme on mount
useTheme()
</script>

<template>
  <component v-if="layout" :is="layout">
    <RouterView />
  </component>
  <RouterView v-else />
  <ConfirmDialog />
</template>
